export default __webpack_public_path__ + "static/media/logo.567457b9.png";